/**
 * ScrollToTop - Automatically scrolls to top on route changes
 * Provides better UX by ensuring users start at the top of new pages
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ============================================================================
// Types
// ============================================================================

interface ScrollToTopProps {
  behavior?: ScrollBehavior;
  children?: React.ReactNode;
}

// ============================================================================
// ScrollToTop Component
// ============================================================================

export const ScrollToTop: React.FC<ScrollToTopProps> = ({
  behavior = 'smooth',
  children,
}) => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior,
    });

    // Also scroll any scrollable containers to top if they exist
    const scrollableElements = document.querySelectorAll(
      '[data-scroll-container]',
    );
    scrollableElements.forEach((element) => {
      element.scrollTo({
        top: 0,
        left: 0,
        behavior,
      });
    });
  }, [pathname, behavior]);

  return <>{children}</>;
};

export default ScrollToTop;
